(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var v = cents / 100;
    return (cents % 100 === 0 ? String(v) : v.toFixed(2).replace('.', ',')) + '\u00a0€';
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function toast(msg) {
    var t = document.querySelector('.sl-toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('is-on'); }, 2800);
  }

  var header = document.querySelector('.sl-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 12); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  var burger = document.querySelector('[data-sl-burger]');
  var nav = document.querySelector('.sl-mobile-nav');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('sl-lock', open);
    });
    nav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        nav.classList.remove('is-open');
        document.documentElement.classList.remove('sl-lock');
      });
    });
  }

  var revealEls = document.querySelectorAll('.sl-reveal');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  var drawer = document.querySelector('.sl-drawer');
  var overlay = document.querySelector('.sl-overlay');
  var UNIT = window.PT_UNIT || 2500;
  function packSize(item) {
    if (!item.properties) return 0;
    return Object.keys(item.properties).filter(function (k) { return /^Parfum \d+$/.test(k) && item.properties[k]; }).length;
  }

  function setCount(n) {
    document.querySelectorAll('[data-sl-count]').forEach(function (el) {
      el.textContent = n;
      el.classList.toggle('is-empty', n === 0);
      el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump');
    });
  }
  function openDrawer() {
    if (!drawer) { window.location.href = root + 'cart'; return; }
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('sl-lock');
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('sl-lock');
  }
  function lineProps(item) {
    if (!item.properties) return '';
    var out = [];
    Object.keys(item.properties).forEach(function (k) {
      var v = item.properties[k];
      if (!v || k.charAt(0) === '_') return;
      out.push('<span>' + esc(k) + ' : ' + esc(v) + '</span>');
    });
    return out.length ? '<div class="sl-line__props">' + out.join('') + '</div>' : '';
  }
  function renderCart(cart) {
    setCount(cart.item_count);
    if (!drawer) return;
    var body = drawer.querySelector('.sl-drawer__body');
    var foot = drawer.querySelector('.sl-drawer__foot');
    if (!cart.items.length) {
      body.innerHTML = '<div class="sl-drawer__empty"><p>Votre panier est vide.</p><a class="sl-btn" href="' + root + '#composer">Composer ma sélection</a></div>';
      foot.hidden = true;
      return;
    }
    var hasPack = cart.items.some(function (i) { return packSize(i) > 1; });
    var saved = 0;
    cart.items.forEach(function (i) { var n = packSize(i); if (n > 1) saved += Math.max(0, n * UNIT * i.quantity - i.final_line_price); });
    var html = cart.items.map(function (item) {
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_240x$1$2') : '';
      return '<div class="sl-line" data-key="' + esc(item.key) + '">' +
        (img ? '<img class="sl-line__img" src="' + esc(img) + '" alt="" width="72" height="90" loading="lazy">' : '') +
        '<div class="sl-line__info"><a href="' + esc(item.url) + '" class="sl-line__title">' + esc(item.product_title) + '</a>' +
        lineProps(item) +
        '<div class="sl-line__row"><div class="sl-qty sl-qty--sm">' +
        '<button type="button" data-q="-1" aria-label="Retirer 1">−</button><output>' + item.quantity + '</output>' +
        '<button type="button" data-q="1" aria-label="Ajouter 1">+</button></div>' +
        '<span class="sl-line__price">' + money(item.final_line_price) + '</span></div></div></div>';
    }).join('');
    if (!hasPack) {
      html += '<a class="sl-upsell" href="' + root + '#composer"><strong>Passez au Duo : 22,50 € / parfum</strong><span>Ajoutez 1 parfum et économisez 5 € →</span></a>';
    }
    body.innerHTML = html;
    foot.hidden = false;
    foot.querySelector('[data-sl-total]').textContent = money(cart.total_price);
    var sv = foot.querySelector('[data-sl-save]');
    if (sv) { sv.hidden = saved <= 0; sv.querySelector('b').textContent = '−' + money(saved); }
  }
  function fetchCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; });
  }
  function changeLine(key, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }
  function addItems(items) {
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Erreur');
        return data;
      });
    }).then(function () { return fetchCart(); }).then(function () { openDrawer(); });
  }
  window.SLCart = { add: addItems, open: openDrawer, refresh: fetchCart };

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) {
        var line = b.closest('.sl-line');
        var out = line.querySelector('output');
        var q = Math.max(0, parseInt(out.textContent, 10) + parseInt(b.dataset.q, 10));
        line.style.opacity = '.5';
        changeLine(line.dataset.key, q);
      }
      if (e.target.closest('[data-sl-close]')) closeDrawer();
    });
    overlay && overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  document.querySelectorAll('[data-sl-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { if (drawer) { e.preventDefault(); fetchCart(); openDrawer(); } });
  });

  document.querySelectorAll('form[data-sl-add]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var id = form.querySelector('[name="id"]').value;
      var qEl = form.querySelector('[name="quantity"]');
      btn.disabled = true;
      btn.classList.add('is-loading');
      addItems([{ id: Number(id), quantity: qEl ? Number(qEl.value) : 1 }])
        .catch(function (err) { toast(err.message); })
        .finally(function () { btn.disabled = false; btn.classList.remove('is-loading'); });
    });
  });

  document.querySelectorAll('[data-sl-gallery]').forEach(function (g) {
    var main = g.querySelector('.sl-gallery__main img');
    g.querySelectorAll('.sl-gallery__thumb').forEach(function (t) {
      t.addEventListener('click', function () {
        g.querySelectorAll('.sl-gallery__thumb').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        main.classList.remove('is-swap'); void main.offsetWidth;
        main.src = t.dataset.src;
        main.srcset = '';
        main.alt = t.dataset.alt || '';
        main.classList.add('is-swap');
      });
    });
  });

  document.querySelectorAll('.sl-faq').forEach(function (faq) {
    faq.addEventListener('toggle', function (e) {
      if (e.target.open) faq.querySelectorAll('details[open]').forEach(function (d) { if (d !== e.target) d.open = false; });
    }, true);
  });

  document.querySelectorAll('[data-sl-composer]').forEach(initComposer);

  function initComposer(el) {
    var dataEl = el.querySelector('script[type="application/json"]');
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var P = data.perfumes || [];
    var PACKS = data.packs || [];
    if (!P.length || !PACKS.length) return;

    var start = PACKS.filter(function (k) { return k.handle === data.start; })[0] ||
      PACKS.filter(function (k) { return k.popular; })[0] || PACKS[0];
    var pack = start;
    var chosen = [];
    var mobile = window.matchMedia("(max-width: 767px)");
    var submitting = false;

    var tabs = el.querySelector('.sl-comp__tabs');
    var slotsEl = el.querySelector('.sl-comp__slots');
    var tray = el.querySelector('.sl-comp__tray');
    var stage = el.querySelector('.sl-comp__stage');
    var list = el.querySelector('.sl-comp__list');
    var status = el.querySelector('.sl-comp__status');
    var priceEl = el.querySelector('[data-price]');
    var wasEl = el.querySelector('[data-was]');
    var perEl = el.querySelector('[data-per]');
    var cta = el.querySelector('.sl-comp__cta');
    var countEl = el.querySelector('.sl-comp__count');
    var giftBox = el.querySelector('.sl-comp__gift');
    var giftMsg = giftBox ? giftBox.querySelector('textarea') : null;
    var resetBtn = el.querySelector('[data-reset]');

    function byId(id) { return P.filter(function (p) { return p.id === id; })[0]; }

    tabs.innerHTML = PACKS.map(function (k) {
      return '<button type="button" class="sl-tab" role="tab" data-h="' + esc(k.handle) + '">' +
        (k.badge ? '<em class="sl-tab__badge">' + esc(k.badge) + '</em>' : '') +
        '<span class="sl-tab__name">' + esc(k.label) + '</span>' +
        '<span class="sl-tab__meta">' + money(k.price) + ' · ' + money(Math.round(k.price / k.size)) + ' / parfum</span></button>';
    }).join('');
    tabs.addEventListener('click', function (e) {
      var b = e.target.closest('.sl-tab');
      if (b) selectPack(b.dataset.h, true);
    });

    var fam = '';
    list.innerHTML = P.map(function (p) {
      var head = '';
      if (p.family !== fam) { fam = p.family; head = '<p class="sl-comp__family">' + esc(fam) + '</p>'; }
      return head + '<div class="sl-comp__item" data-id="' + p.id + '">' +
        '<div class="sl-comp__thumb" style="--juice:' + esc(p.color) + '"><img src="' + esc(p.thumb) + '" alt="' + esc(p.name) + '" width="120" height="150" loading="lazy"></div>' +
        '<div class="sl-comp__info"><span class="sl-comp__name">' + esc(p.name) + '</span><span class="sl-comp__notes">' + esc(p.notes) + '</span></div>' +
        '<div class="sl-qty"><button type="button" data-a="-" aria-label="Retirer ' + esc(p.name) + '">−</button><output>0</output>' +
        '<button type="button" data-a="+" aria-label="Ajouter ' + esc(p.name) + '">+</button></div>' +
        '<button type="button" class="sl-comp__mobile-add" data-a="+" aria-label="Ajouter ' + esc(p.name) + ' au pack">+ Ajouter au pack</button></div>';
    }).join('');
    var cards = Array.from(list.querySelectorAll('.sl-comp__item'));
    list.setAttribute('tabindex', '0');
    list.setAttribute('aria-label', 'Parfums à choisir. Faites défiler pour découvrir la sélection.');
    var scrollFrame = 0;
    function highlightCard() {
      scrollFrame = 0;
      if (!mobile.matches) return;
      var bounds = list.getBoundingClientRect();
      var center = bounds.left + bounds.width / 2;
      var nearest = 0, distance = Infinity;
      cards.forEach(function (card, i) {
        var r = card.getBoundingClientRect();
        var d = Math.abs(r.left + r.width / 2 - center);
        if (d < distance) { distance = d; nearest = i; }
      });
      cards.forEach(function (card, i) { card.classList.toggle('is-active', i === nearest); });
    }
    cards[0].classList.add('is-active');
    list.addEventListener('scroll', function () {
      if (!scrollFrame) scrollFrame = requestAnimationFrame(highlightCard);
    }, { passive: true });
    list.addEventListener('keydown', function (e) {
      if (!mobile.matches || (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft')) return;
      e.preventDefault();
      var i = cards.findIndex(function (card) { return card.classList.contains('is-active'); });
      i = Math.max(0, Math.min(cards.length - 1, i + (e.key === 'ArrowRight' ? 1 : -1)));
      list.scrollTo({ left: cards[i].offsetLeft - cards[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-a]');
      if (!b) return;
      var id = Number(b.closest('.sl-comp__item').dataset.id);
      if (b.dataset.a === '+') add(id); else removeOne(id);
    });

    function renderSlots(popIdx) {
      tray.classList.toggle('is-gift', !!pack.gift);
      tray.classList.toggle('is-full', chosen.length === pack.size);
      tray.style.setProperty('--cols', pack.size === 7 ? 4 : pack.size);
      var h = '';
      for (var i = 0; i < pack.size; i++) {
        var p = chosen[i] ? byId(chosen[i]) : null;
        if (p) {
          h += '<button type="button" class="sl-slot is-filled' + (i === popIdx && !reduce ? ' is-pop' : '') + '" data-i="' + i + '" aria-label="Retirer ' + esc(p.name) + ' de la sélection">' +
            '<span class="sl-slot__remove" aria-hidden="true">×</span><img src="' + esc(p.thumb) + '" alt="" width="240" height="300"><span class="sl-slot__name">' + esc(p.name) + '</span></button>';
        } else {
          h += '<div class="sl-slot" data-i="' + i + '"><span>' + (i + 1) + '</span></div>';
        }
      }
      slotsEl.innerHTML = h;
    }
    slotsEl.addEventListener('click', function (e) {
      var s = e.target.closest('.sl-slot.is-filled');
      if (!s || pack.auto) return;
      chosen.splice(Number(s.dataset.i), 1);
      update();
    });

    function tint() {
      var last = chosen.length ? byId(chosen[chosen.length - 1]) : null;
      stage.style.setProperty('--tint', last && !pack.gift ? last.color : 'transparent');
    }

    function update(popIdx) {
      renderSlots(popIdx);
      tint();
      var left = pack.size - chosen.length;
      countEl.textContent = chosen.length + ' / ' + pack.size;
      if (left > 0) {
        status.innerHTML = 'Encore <b>' + left + ' parfum' + (left > 1 ? 's' : '') + '</b> à choisir.';
      } else {
        status.innerHTML = '<b>Votre sélection est complète.</b>';
      }
      priceEl.textContent = money(pack.price);
      wasEl.textContent = pack.compare > pack.price ? money(pack.compare) : '';
      perEl.textContent = money(Math.round(pack.price / pack.size)) + ' / parfum' + (pack.compare > pack.price ? ' · Économisez ' + money(pack.compare - pack.price) : '');
      cta.disabled = submitting || left > 0 || !pack.available;
      cta.textContent = !pack.available ? 'Bientôt disponible' : left > 0 ? 'Choisissez encore ' + left + ' parfum' + (left > 1 ? 's' : '') : 'Ajouter au panier · ' + money(pack.price);
      if (mobile.matches && pack.available) {
        cta.textContent = left > 0
          ? 'Choisissez ' + (chosen.length ? 'encore ' : '') + left + ' parfum' + (left > 1 ? 's' : '')
          : 'Ajouter mon ' + pack.label.split(' · ')[0] + ' au panier — ' + money(pack.price);
      }
      if (giftBox) giftBox.hidden = true;
      if (resetBtn) resetBtn.hidden = !chosen.length;
      list.querySelectorAll('.sl-comp__item').forEach(function (it) {
        var id = Number(it.dataset.id);
        var n = chosen.filter(function (x) { return x === id; }).length;
        it.querySelector('output').textContent = n;
        it.classList.toggle('is-picked', n > 0);
        it.querySelector('[data-a="-"]').disabled = n === 0;
        it.querySelectorAll('[data-a="+"]').forEach(function (button) { button.disabled = submitting || left === 0; });
      });
      tabs.querySelectorAll('.sl-tab').forEach(function (t) {
        t.setAttribute('aria-selected', t.dataset.h === pack.handle ? 'true' : 'false');
      });
    }

    function fly(id, idx, done) {
      var from = list.querySelector('.sl-comp__item[data-id="' + id + '"] .sl-comp__thumb img');
      var to = slotsEl.querySelector('.sl-slot[data-i="' + idx + '"]');
      if (reduce || !from || !to) { done(); return; }
      var a = from.getBoundingClientRect(), b = to.getBoundingClientRect();
      if (b.bottom < 0 || b.top > window.innerHeight) { done(); return; }
      var clone = from.cloneNode();
      clone.className = 'sl-fly';
      clone.style.left = a.left + 'px';
      clone.style.top = a.top + 'px';
      clone.style.width = a.width + 'px';
      clone.style.height = a.height + 'px';
      document.body.appendChild(clone);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          clone.style.transform = 'translate(' + (b.left - a.left) + 'px,' + (b.top - a.top) + 'px) scale(' + (b.width / a.width) + ',' + (b.height / a.height) + ')';
          clone.style.opacity = '0.4';
        });
      });
      setTimeout(function () { clone.remove(); done(); }, 520);
    }

    function add(id) {
      if (submitting || chosen.length >= pack.size) return;
      var idx = chosen.length;
      chosen.push(id);
      update(-1);
      var slot = slotsEl.querySelector('.sl-slot[data-i="' + idx + '"]');
      if (slot) slot.style.visibility = 'hidden';
      fly(id, idx, function () { update(idx); });
    }
    function removeOne(id) {
      var i = chosen.lastIndexOf(id);
      if (i > -1) { chosen.splice(i, 1); update(); }
    }

    function selectPack(handle) {
      var k = PACKS.filter(function (x) { return x.handle === handle; })[0];
      if (!k) return;
      pack = k;
      chosen = chosen.slice(0, pack.size);
      update();
    }

    resetBtn && resetBtn.addEventListener('click', function () { chosen = []; update(); });

    cta.addEventListener('click', function () {
      if (cta.disabled) return;
      var props = {};
      chosen.forEach(function (id, i) { props['Parfum ' + (i + 1)] = byId(id).name; });
      cta.disabled = true;
      cta.classList.add('is-loading');
      addItems([{ id: pack.variantId, quantity: 1, properties: props }])
        .then(function () { chosen = []; update(); })
        .catch(function (err) { toast(err.message); update(); })
        .finally(function () { submitting = false; cta.classList.remove('is-loading'); update(); });
    });

    selectPack(pack.handle);
    mobile.addEventListener('change', function () { update(); highlightCard(); });

    document.addEventListener('pt:prefill', function (e) {
      var d = e.detail || {};
      selectPack(d.pack);
      chosen = [];
      if (d.id && byId(d.id)) chosen.push(d.id);
      update(chosen.length ? 0 : -1);
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  document.querySelectorAll('[data-pt-offer]').forEach(function (b) {
    b.addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('pt:prefill', { detail: { pack: b.dataset.pack, id: Number(b.dataset.id) } }));
    });
  });

  fetchCart().catch(function () {});
})();
